export default class StateSerializer {
  static serialize(data) {
    return {
      id: data.id,
      name: data.name,
      companyId: data.companyId,
      countryId: data.countryId
    };
  }

  static deSerialize(data) {
    return {
      id: data.id,
      name: data.name,
      companyId: data.companyId,
      countryId: data.countryId
    };
  }
}